import React from "react";
import "./index.css";

const PhoneNumbers = () => {
    return (
        <div className="phone-numbers">
            {
                [
                    { number: "+37410575752", display: "010 57 57 52" },
                    { number: "+37495575752", display: "+374 95 57 57 52" },
                    { number: "+37499575752", display: "+374 99 57 57 52" }
                ].map((phone, index) => (
                    <a key={index} className="phone" href={`tel:${phone.number}`}>
                        <i className="fa fa-volume-control-phone" aria-hidden="true"></i>
                        {phone.display}
                    </a>
                ))
            }
        </div>
    )
}
export default PhoneNumbers;